import { render, staticRenderFns } from "./TableRowTestsSubtotal.vue?vue&type=template&id=6bcaf137&lang=pug&"
import script from "./TableRowTestsSubtotal.vue?vue&type=script&lang=js&"
export * from "./TableRowTestsSubtotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bcaf137')) {
      api.createRecord('6bcaf137', component.options)
    } else {
      api.reload('6bcaf137', component.options)
    }
    module.hot.accept("./TableRowTestsSubtotal.vue?vue&type=template&id=6bcaf137&lang=pug&", function () {
      api.rerender('6bcaf137', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/tracking-sheet/table-rows/TableRowTestsSubtotal.vue"
export default component.exports